import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ContextContainerWidget: WidgetRegistryEntry = {
  name: "ContextContainer",
  configuration: () => import("./configuration").then((module) => module.ContextContainerWidgetConfiguration),
  component: () =>
    import("./context-container-widget.component").then((module) => module.ContextContainerWidgetComponent)
};
